import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/hotel-manage',
            name: 'hotel-manage',
            component: () => import(/* webpackChunkName: "page-admin-hotel-manage" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "酒店管理"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "酒店列表"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
